import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FondyInvoiceContainer.css';
import closeUrl from '../../../mobile/components/Modal/cross.svg';
import Invoice from '../Invoice/Invoice';

class FondyInvoiceContainer extends React.Component {
  static propTypes = {
    billAmount: PropTypes.string.isRequired,
    accountNumber: PropTypes.string.isRequired,
    closeHandler: PropTypes.func.isRequired,
  };
  render() {
    const { billAmount, accountNumber, closeHandler } = this.props;
    return (
      <div className={s.Froot}>
        <div className={s.Fbg} onClick={closeHandler} />
        <div className={s.Fcontainer}>
          <button className={s.Fclose} onClick={closeHandler}>
            <img alt="" src={closeUrl} width="15" />
          </button>
          <Invoice billAmount={billAmount} accountNumber={accountNumber} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(FondyInvoiceContainer);



// WEBPACK FOOTER //
// ./src/shared/components/FondyFrame/FondyInvoiceContainer.js